import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Autocomplete } from 'components/FormFields';
import { types } from 'constants/userGroups';
import i18n from 'i18n-js';
import { generateFilterOptions } from 'utils';
const UserGroupsTypesSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  className,
  asyncErrors,
  margin,
  disabled,
  required,
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = types.find((type) => type === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, types]) // eslint-disable-line

  const handleShowError = () => {
    if (asyncErrors) {
      return asyncErrors;
    } else if (errors && errors[name] && touched[name]) {
      return errors[name];
    }
  };

  const handleError = () => {
    if (asyncErrors) {
      return true;
    } else if (errors && errors[name] && touched && touched[name]) {
      return true;
    }
  };

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      required={required}
      disabled={disabled}
      value={defaultValue}
      className={className}
      error={handleError()}
      id="user-groups-types"
      filterOptions={filterOptions}
      helperText={handleShowError()}
      options={types.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) =>
        option ? i18n.t(`user_groups.types.${option}`) : option === value || ''
      }
      onChange={(ev, val) => setFieldValue(name, val || '')}
      getOptionLabel={(option) => (option ? i18n.t(`user_groups.types.${option}`) : '')}
    />
  );
};

UserGroupsTypesSelect.propTypes = {
  label: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  omitFields: PropTypes.array,
  asyncErrors: PropTypes.string,
};

UserGroupsTypesSelect.defaultProps = {
  required: false,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  margin: 'normal',
  variant: 'standard',
  label: 'User Group Type',
};

export default UserGroupsTypesSelect;
